import * as angular from 'angular';
import * as _ from 'lodash';
import * as React from 'react';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEvents} from "../../shared/dto/aps.events";
import {apsEnums} from "../../shared/dto/aps.enums";
import {CheckListReportData} from "./checkListReport.controller";
import DateUtilityService from "../../services/utility/dateutility.service";
import CheckListInstancesServiceName, {CheckListInstancesService} from "../../services/checkLists/checkListInstances.service";
import CheckListsServiceName, {CheckListsService} from "../../services/checkLists/checkLists.service";
import LoaderServiceName, {LoaderService} from "../../components/loader/loader.service";
import CheckListInstancesHubName, {CheckListInstancesHub, CheckListInstancesHubCreator} from "../../services/checkLists/checkListInstances.hub";
import CheckListReportDetails, {openCheckListReportDetails} from "./checkListReportDetails.controller";
import FillOutCheckListName, {openFillOutCheckList} from "../checks/fillOutCheckList.controller";
let requires = [CheckListReportDetails, CheckListInstancesServiceName, CheckListsServiceName, LoaderServiceName,
  CheckListInstancesHubName, FillOutCheckListName];

interface CheckListReportState {
  results: apsViewModels.CheckListReportItem[];
}

class CheckListReportComponent extends React.Component<CheckListReportData, CheckListReportState> {
  static checkListInstancesService: CheckListInstancesService;
  static checkListsService: CheckListsService;
  static loaderService: LoaderService;
  static $modal: mm.foundation.modal;
  static checkListInstancesHubCreator: CheckListInstancesHubCreator;

  private hub: CheckListInstancesHub;

  componentDidMount() {
    if (!this.props && !this.props.results) {
      this.setState({results: null});
      return;
    }

    this.setState({results: this.props.results});

    this.createOrSubscribeHub(this.props);
  }

  private createOrSubscribeHub(props: CheckListReportData) {
    if (!props || !props.plantId) {
      return;
    }

    if (this.hub) {
      this.hub.joinGroup(props.plantId, props.shopId);
    } else {
      this.hub = CheckListReportComponent.checkListInstancesHubCreator
        .createCheckListInstancesHub(props.plantId, props.shopId,
          (updated) => this.handleUpdated(updated),
          (instance) => this.handleInstance(instance));
    }
  }

  componentWillReceiveProps(props: CheckListReportData) {
    if (!props && !props.results) {
      this.setState({results: null});
      return;
    }

    this.setState({results: props.results});
    this.createOrSubscribeHub(props);
  }

  componentWillUnmount() {
    if (this.hub) {
      this.hub.uninitialize();
    }
  }

  private findExistingInstance(instance: {id: string, checkListId: string}): apsViewModels.CheckListInstanceReportItem {
    var group = _.find(this.state.results, {checkListId: instance.checkListId});
    if (group) {
      return _.find(group.checkListInstances, {id: instance.id});
    }
    return null;
  }

  private handleUpdated(updated: apsEvents.CheckListInstancesUpdated) {
    if (!this.state.results) {
      return;
    }

    if (updated.instances.length > 0) {
      _.forEach(updated.instances, i => this.handleUpdated(i));
    }

    var existing = this.findExistingInstance(updated);
    if (!existing) {
      return;
    }

    if (updated.action === apsEnums.EventAction.Delete) {
      var group = _.find(this.state.results, {checkListId: updated.checkListId});
      if (group) {
        _.remove(group.checkListInstances, existing);
        if (group.checkListInstances.length === 0) {
          _.remove(this.state.results, group);
        }
      }
    } else {
      existing.status = updated.status;
      existing.result = updated.result;
    }
    this.setState({results: this.state.results});
  }

  private handleInstance(instance: apsViewModels.CheckListInstanceItemEvent) {
    if (!this.state.results || instance.action === apsEnums.EventAction.Add) {
      return;
    }

    if (instance.instances.length > 0) {
      _.forEach(instance.instances, i => this.handleInstance(i));
    }

    var existing = this.findExistingInstance(instance);
    if (!existing) {
      return;
    }

    existing.status = instance.status;
    existing.result = instance.result;
    this.setState({results: this.state.results});
  }

  render(): JSX.Element {
    if (!this.state || !this.state.results) {
      return React.createElement('div', {key: 'results'}, ' ');
    }

    if (this.state.results.length === 0) {
      return React.createElement('div', {key: 'results'},
        'No results found. Please select a different plant, location, date range and/or check list.');
    }

    var rows = this.createRows();

    return React.createElement('table', {key: 'results', className: 'history-t'},
      React.createElement('thead', {key: 'results-head'},
        React.createElement('tr', {key: 'results-head-tr'},
          React.createElement('th', {key: 'head-name'}, 'Name'),
          React.createElement('th', {key: 'head-schedule'}, 'Scheduled On'),
          React.createElement('th', {key: 'head-status'}, 'Status'),
          React.createElement('th', {key: 'head-plant'}, 'Plant'),
          React.createElement('th', {key: 'head-location'}, 'Location'),
          React.createElement('th', {key: 'head-result'}, 'Results'),
          React.createElement('th', {key: 'head-open'}, ' ')
        )
      ),
      React.createElement('tbody', {key: 'results-body'}, rows)
    );
  }

  private createRows(): JSX.Element[] {
    var rows: JSX.Element[] = [];

    _.forEach(this.state.results, (checkGroup: apsViewModels.CheckListReportItem) => {
      var instances = _.sortBy(checkGroup.checkListInstances,
        ['scheduledOn', 'plantName', 'location'],
        [false, true, true]
      );

      rows.push(React.createElement('tr', {key: 'group-' + checkGroup.checkListId}),
        React.createElement('td', {key: 'name' + checkGroup.checkListId, colSpan: '7'} as React.ClassAttributes<Element>,
          checkGroup.checkListName + ' (' + instances.length.toString() + ')'
        )
      );

      _.forEach(instances, (instance: apsViewModels.CheckListInstanceReportItem) => {
        var resultClass = instance.result
          ? (instance.result === apsEnums.CheckListResult.Pass
              ? 'checklist-pass'
              : (instance.result === apsEnums.CheckListResult.Fail
                  ? 'checklist-fail'
                  : 'checklist-incomplete'
                )
            )
          : 'checklist-incomplete';

        var buttons = [
          React.createElement('button', {
            className: 'button tiny',
            style: {margin: '0'},
            onClick: () => this.view(instance)
          }, 'View')
        ];

        if (this.canEdit(instance)) {
          buttons.push(React.createElement('button', {
            className: 'button tiny',
            style: {margin: '0 0 0 7px'},
            onClick: () => this.edit(instance)
          }, 'Edit'));
        }

        rows.push(React.createElement('tr', {key: instance.id},
          React.createElement('td', {key: 'name'}, [
            React.createElement('span', {style: {width: '20px', display: 'inline-block'}}, ' '),
            instance.checkListName
          ]),
          React.createElement('td', {key: 'schedule'},
            this.formatTime(instance.scheduledOn, instance.plantTimeZoneId)
          ),
          React.createElement('td', {key: 'status'},
            this.formatStatus(instance.status)
          ),
          React.createElement('td', {key: 'plantName'}, instance.plantName),
          React.createElement('td', {key: 'location'}, instance.locationName),
          React.createElement('td', {key: 'result'},
            React.createElement('span', {className: resultClass},
              this.formatResult(instance.result)
            )
          ),
          React.createElement('td', {key: 'open', className: 'right'}, buttons)
        ));
      });
    });

    return rows;
  }

  private formatStatus(status: apsEnums.CheckListStatus): string {
    return _.startCase(apsEnums.CheckListStatus[status]);
  }

  private formatResult(result: apsEnums.CheckListResult): string {
    return _.startCase(apsEnums.CheckListResult[result]);
  }

  private formatTime(time: Date, timeZoneId: string): string {
    return DateUtilityService.formatTime(time, timeZoneId);
  }

  private canEdit(checkListInstance: apsViewModels.CheckListInstanceReportItem): boolean {
    if (checkListInstance.checkListIsGroup) {
      return false;
    }

    if (checkListInstance.status === apsEnums.CheckListStatus.Pending) {
      return false;
    }

    return CheckListReportComponent.checkListInstancesService
      .isAuthorizedForPlant(checkListInstance, this.props.plantId);
  }

  private view(instance: apsViewModels.CheckListInstanceReportItem): void {
    var promise = CheckListReportComponent.checkListsService
      .getCheckListReportDetail(instance.id, instance.plantLocationId, instance.scheduledOn, this.props.filter);
    CheckListReportComponent.loaderService.loadingPromise(promise);

    promise.then((data: apsViewModels.CheckListInstanceReportDetail) => {
      openCheckListReportDetails({
        checkListInstance: instance,
        detail: data
      }, CheckListReportComponent.$modal);
    });
  }

  private edit(checkListInstance: apsViewModels.CheckListInstanceReportItem): void {
    var result = openFillOutCheckList({
      checkListId: checkListInstance.checkListId,
      instanceId: checkListInstance.id,
      plantId: checkListInstance.plantId,
      tankId: checkListInstance.tankId,
      shopId: checkListInstance.shopId,
      plantLocationId: checkListInstance.plantLocationId,
      readOnly: false,
      scheduledOn: checkListInstance.scheduledOn
    }, CheckListReportComponent.$modal);

    result.then((cmd) => {
      CheckListReportComponent.checkListInstancesService
        .updateStatusAndResult(checkListInstance, cmd);
    });
  }
}

export default angular.module('aps.controller.checkListReport.react', requires)
  .factory('CheckListReportComponent', (
    checkListInstancesService: CheckListInstancesService,
    checkListsService: CheckListsService,
    loaderService: LoaderService,
    $modal: mm.foundation.modal,
    checkListInstancesHubCreator: CheckListInstancesHubCreator) => {

    CheckListReportComponent.checkListInstancesService = checkListInstancesService;
    CheckListReportComponent.checkListsService = checkListsService;
    CheckListReportComponent.loaderService = loaderService;
    CheckListReportComponent.$modal = $modal;
    CheckListReportComponent.checkListInstancesHubCreator = checkListInstancesHubCreator;
    return CheckListReportComponent;
  })
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/checkLists/checkListReportReact.ts